import React from 'react';

import { CollectionFieldSchema } from '@candu-ai/collections/types';
import { CollectionSelectInput } from 'craft/components/SelectedToolbar/Collections/components';

export interface CollectionContentSelectorProps {
  selectedField: string;
  availableFields?: CollectionFieldSchema[];
  onSelectField: (fieldId: string) => void;
  hasError: boolean;
}

type Item = {
  value: string;
  label: string;
};

export const FieldContentSelector = ({
  availableFields,
  selectedField,
  onSelectField,
  hasError,
}: CollectionContentSelectorProps) => {
  if (!availableFields) {
    return <></>;
  }

  const fieldsWithoutNone: Item[] = availableFields.map((field) => ({
    value: field.id,
    label: `${field.name} (${field.type})`,
  }));

  const fields = [{ value: '', label: 'None' }, ...fieldsWithoutNone];

  const isFieldUnavailable = fields.length === 1 && typeof fields[0].value === 'undefined';

  return (
    <CollectionSelectInput
      data-cy="field-select"
      placeholder={isFieldUnavailable ? 'No fields available' : 'Select a field'}
      items={fields}
      selectedItem={fields.find(({ value }) => value === selectedField)}
      // @ts-ignore
      onSelect={(selected: Item) => onSelectField(selected?.value as string)}
      scale="small"
      clearable={!!selectedField}
      hasError={hasError || isFieldUnavailable}
      disabled={isFieldUnavailable}
    />
  );
};
